import { Component, HostListener, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ListGroupComponent } from '../list-group/list-group.component';
import { SelectableInputBaseComponent } from '../selectable-input-base.component';

@Component({
    selector: 'selectable-button',
    styleUrls: ['./selectable-button.scss'],
    template: `
        <input
            (click)="onClick()"
            [class.open]="searches.length"
            type="button"
            [ngModel]="value"
            (input)="startSearch($event)"
            class="form-control"
            #input [id]="id"
        />
        <i (click)="onClick()" class="fa-light fa-angle-down input-arrow pointer"></i>
        
        <list-group
            (listClicked)="onSelect($event)"
            [optionalText]="optionalText"
            [optionsText]="optionsText"
            [optionGroupHeader]="optionGroupHeader"
            [defaultValue]="defaultValue"
            [stayOpen]="stayOpen"
            [showList]="showList"
            [searches]="searches"
            [class.static]="stayOpen"
            [optionGroupCount]="optionGroupCount"
        ></list-group>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ListGroupComponent]
})
export class SelectableButtonComponent<T> extends SelectableInputBaseComponent<T> {

	@HostListener('document:click', ['$event']) onStart(event: any) {
		let id = event?.target?.id;
		this.showList = id === 'selectableButton';
	}

	@Input() declare optionGroupHeader;

	@Input() optionGroupCount: number;

	@Input() id: string;

	public onClick() {
		setTimeout(() => {
			this.setSearchData("");
		});
	}



	public onSelect(search: T | null) {
		this.value = search ? this.optionsText(search) : this.optionalText;
		this.valueChange.emit(search);

		if (this.stayOpen) {
			return;
		}

		this.searches = [];
		this.showList = false;
	}

}
